import { render, staticRenderFns } from "./pdfview.vue?vue&type=template&id=12248c14&scoped=true"
import script from "./pdfview.vue?vue&type=script&lang=js"
export * from "./pdfview.vue?vue&type=script&lang=js"
import style0 from "./pdfview.vue?vue&type=style&index=0&id=12248c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12248c14",
  null
  
)

export default component.exports